import { render, staticRenderFns } from "./repairDetail.vue?vue&type=template&id=0687d604&scoped=true"
import script from "./repairDetail.vue?vue&type=script&lang=js"
export * from "./repairDetail.vue?vue&type=script&lang=js"
import style0 from "./repairDetail.vue?vue&type=style&index=0&id=0687d604&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0687d604",
  null
  
)

export default component.exports